































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ThDropdownVue from "../components/ThDropdown.vue";
import ReportStatusVue from "@/components/TaxDeclaration/ReportStatus.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ViewAccountBookVue from "@/components/AccountBookList/ViewAccountBook.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import PayRollTaxVue from "../components/Payroll/PayRollTax.vue";
import ThDatePickerVue from "../components/ThDatePicker.vue";

// import HfLoading from "@/components/Loading/HfLoading";

@Component({
    ...mapGetters(["account"]),
    components: {
        "th-dropdown": ThDropdownVue,
        "th-date": ThDatePickerVue,
        "month-selector": MonthSelectorVue,
        "view-book": ViewAccountBookVue,
        "report-status": ReportStatusVue,
        "user-tree": AllUserTreeVue,
        "payroll-tax": PayRollTaxVue,
    },
})
export default class TaxTask extends Vue {
    showTax: boolean = false;
    collectPeriod: string = this.$store.state.collectPeriod;
    clientList: any[] = [];
    records: any[] = [];
        // 人员组织
        accounterName: string = "所属人姓名";
    // 打开tree
    isTree: boolean = false;
    openTree() {
        this.isTree = !this.isTree;
    }
    // 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
    tmp: UserTree | null = null;
    treeExpand(data: UserTree) {
        this.tmp = data;
    }
    // 点击tree中的名字(node)
    isScope: boolean = false;
    handleNodeClick(data: Account) {
        this.isScope = true;
        if (data.name) this.accounterName = data.name;
        this.currentPage = 1;
        this.$store.dispatch("clearSearchKey");
        this.accounterNo = data.no;
        if (this.flowType === 33 || this.flowType === 44) this.getList();
        else this.fetchData();
        this.isTree = false;
    }
    // 关闭tree
    closeTree() {
        this.isTree = false;
    }
    taxList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 111,
        },
        {
            text: "个税",
            id: 201,
        },
        {
            text: "个税扣款",
            id: 202,
        },
        {
            text: "个税作废",
            id: 203,
        },
        {
            text: "生产经营",
            id: 601,
        },
        {
            text: "生产经营扣款",
            id: 602,
        },
        {
            text: "生产经营作废",
            id: 603,
        },
        {
            text: "财务报表",
            id: 101,
        },
        {
            text: "增值税",
            id: 102,
        },
        {
            text: "所得税",
            id: 103,
        },
        {
            text: "其他税种",
            id: 104,
        },
        {
            text: "电子税务局扣款",
            id: 105,
        },
        {
            text: "电子税务局作废",
            id: 106,
        },
        {
            text: "电子税务局检查",
            id: 107,
        },
        {
            text: "社保",
            id: 501,
        },
        {
            text: "社保扣款",
            id: 502,
        },
        {
            text: "社保作废",
            id: 503,
        },
        {
            text: "社保检查",
            id: 504,
        },
    ];
    chargeList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        // {
        //     text: "未申报",
        //     id: 1,
        // },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "运行中",
            id: 3,
        },
        {
            text: "已完成",
            id: 4,
        },
        {
            text: "异常",
            id: 5,
        },
        {
            text: "无需申报",
            id: 6,
        }
    ];
    height: string = "371px";
    // 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
        this.delButton = "批量下载";
        this.perButton = "批量申报"
        this.showCheck = false;
        this.notAllow = false;
        this.showPerChange = false;
        this.clickPer = false;
        this.batch = 0;
        if (this.flowType === 33 || this.flowType === 44) this.getList();
        else this.fetchData();
    }
    // 批量申报
    resave(id?:any) {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].id);
        }
        if(id) {
            ids = id
        }else {
            if(arr.length ===0) {
                this.$message.warning("请选择需要申报的账套");
                return
            }else ids = arr.join(",");
        }
            
            Vue.axios
                .post(
                    `tax/record/resave/list?ids=${ids}`,
                    {}
                )
                .then((res) => {
                    if (res.data) {
                        this.$msgbox({
                            message: res.data,
                            title: "温馨提示",
                            confirmButtonText: "确定",
                            showCancelButton: false,
                        }).then((action: any) => {
                        });
                        this.initPl()
                    }
                    this.fetchData();
                });
    }
    // 批量删除
    del(id?:any) {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].id);
        }
        if(id) {
            ids = id
        }else {
            if(arr.length ===0) {
                this.$message.warning("请选择需要申报的账套");
                return
            }else ids = arr.join(",");
        }
            
            Vue.axios
                .post(
                    `tax/record/delete/list?ids=${ids}`,
                    {}
                )
                .then((res) => {
                    if (res.data) {
                        this.$msgbox({
                            message: res.data,
                            title: "温馨提示",
                            confirmButtonText: "确定",
                            showCancelButton: false,
                        }).then((action: any) => {
                        });
                        this.initPl()
                    }
                    this.fetchData();
                });
    }
    // 搜索
    searchQuery: string = "";
    startSearch() {
        this.currentPage = 1;
        this.fetchData();
    }
    // 日期筛选
    dateValue: string = ""
    chooseDate(date: string) {
        // let days = new Date(2022,2,0).getDate()
        this.dateValue = date
        this.$nextTick(() => {
            this.fetchData()
        })
    }
    //改变时间
    period: string = ""; // 日期
    dateRange: string[] = [
    ]
    changeDate(date: string, end: string) {
        this.$store.dispatch("setClosePeriod", null);
        this.$store.dispatch("changeStartPeriod", "202001");
        this.$store.dispatch("changeCurrentPeriod", end);
        this.period = date;
        let start = this.period.substring(0, 4) + "-" + ((+this.period.substring(4) + 1) < 10 ? ("0" + (+this.period.substring(4) + 1).toString()) : (+this.period.substring(4) + 1).toString()) + "-" + "01"
        let day = ((new Date(+(this.period.substring(0, 4)), +(this.period.substring(4)) + 1, 0).getDate()).toString())
        let month = this.period.substring(0, 4) + "-" + ((+this.period.substring(4) + 1) < 10 ? ("0" + (+this.period.substring(4) + 1).toString()) : (+this.period.substring(4) + 1).toString())
        let ent = (month + "-" + day)
        this.dateRange = [
            start,
            ent
        ]
        this.dateValue = "";
        this.currentPage = 1;
        if (this.flowType === 33) this.getList();
        else this.fetchData();
    }
    batch: number = 0;
    showCheck: boolean = false;
    clickPer: boolean = false;
    notAllow: boolean = false;
    delButton: string = "";
    perButton: string = "批量申报";
    showPerChange: boolean = false; //展示修改时间
    checkChange() { }
    // 批量切换
    commandName:string = ""
    isPL: boolean = false
    plBtn: string = "取消"
    initPl() {
		this.showCheck = false;
		this.isPL = false;
		this.plBtn = "取消";
	}
    plClick() {
		if (this.plBtn === "取消") {
			this.isPL = false;
			this.showCheck = false;
		}
		if (this.plBtn === "批量申报") {
			this.resave();
		}
        if (this.plBtn === "批量删除") {
			this.del();
		}
	}
    batchList(command: string) {
        this.showCheck = true;
		this.isPL = true;
        this.commandName = command
    }
    // 下拉
    chargeStatus: DataTable.DropItem = this.chargeList[0];
    taxStaxtus: DataTable.DropItem = this.taxList[0];

    // 分页
    pageSize: number = 15;
    currentPage: number = 1;
    totalElements: number = 5;

    searchKey: string = "";
    // 是否展示check td
    isShowTd() {
        if (this.batch === 2 || this.batch === 1 || this.batch === 3 || this.batch === 4 || this.batch === 5 || this.batch === 6 || this.batch === 7 || this.batch === 8 || this.batch === 9 || this.batch === 10) return true
        else return false
    }
    idCheckDisable(data: any) {
        if(this.commandName === "批量申报") {
            if(data.taxState === 5) return false
            else return true
        }
        if(this.commandName === "批量删除") {
            if(data.taxState === 2) return false
            else return true
        }
        if(this.commandName === "批量下载") {
            if(data.taxState === 4 || data.taxState === 6) return false
            else return true
        }
    }
    isShowCheck(data: any) {
        if (this.batch === 7 && !data.isWarning && data.taxState === 4) return true;
        else if (this.batch === 6 && data.isWarning) return true;
        else if (this.batch === 10 && !data.isWarning) return true;
        else if (this.batch === 2 && !data.isWarning) return true;
        else if (this.batch === 4 || this.batch === 5 || this.batch === 8 || this.batch === 3 || this.batch === 9) return true;
        else if (this.batch === 1 && !data.isWarning) return true;
        else return false;
    }
    // 获取社保期间
    getSbTime() {
        let time = this.$utils.dateAdd(new Date(), "m", -1)
        console.log(this.$utils.simpleDateFormat(new Date(time), "m"))
        return this.$utils.simpleDateFormat(new Date(time), "m")
    }
    //征期延期判断
    getIsOpen() {
        let time = this.$utils.dateAdd(new Date(), "m", -1)
        if (this.period >= this.$utils.simpleDateFormat(new Date(time), "m")) {
            return true
        } else return false
    }
    mounted() {
        if (this.$route.query.accounterNo) {
            this.accounterNo = this.$route.query.accounterNo;
        }
        // this.fetchData();
    }
    chooseType() {
        this.currentPage = 1;
        this.fetchData();
    }
    taxSuccess(val: any) {
        this.showTax = false;
        this.batchClicks(val);
        // this.fetchData();
    }
    closeTax() {
        this.showTax = false;
        // this.fetchData();
    }
        // 查看图片
        showImg: boolean = false;
    imgSrc: string = "";
    imgList: string[] = [];
    changeImg(img: string) {
        this.imgSrc = img;
        this.imgList = [img];
        this.showImg = true;
    }
    imgWidth: number = 100;
    imgHeight: number = 100;
    plus() {
        if (this.imgWidth < 160) {
            this.imgWidth = this.imgWidth + 10;
        }
        if (this.imgHeight < 160) {
            this.imgHeight = this.imgHeight + 10;
        }
    }
    cut() {
        if (this.imgWidth > 100) {
            this.imgWidth = this.imgWidth - 10;
        }
        if (this.imgHeight > 100) {
            this.imgHeight = this.imgHeight - 10;
        }
    }
    reSet() {
        this.imgHeight = 100;
        this.imgWidth = 100;
    }
    // 自然人报税
    batchClicks(val: any) {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            Vue.axios
                .post(
                    `tax/record/save?period=${this.period}&ids=${ids}&flowType=${this.flowType}&isLastMonth=${val}`,
                    {}
                )
                .then((res) => {
                    if (res.data) {
                        this.$msgbox({
                            message: res.data,
                            title: "温馨提示",
                            confirmButtonText: "确定",
                            showCancelButton: false,
                        }).then((action: any) => {
                        });
                    }
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要申报的账套");
        }
    }
    actiondList = [
        {
            name: "财务报表",
            id: 101
        },
        {
            name: "增值税",
            id: 102
        },
        {
            name: "所得税",
            id: 103
        },
        {
            name: "其他税种",
            id: 104
        },
    ]
    actionIds = [101, 102, 103, 104]
    showAction: boolean = false;
    // 批量报税
    closeBatch() {
        this.actionIds = [101, 102, 103, 104]
        this.showAction = false
    }
    batchAdd() {
        let arr = [];
        let ids = "";
        if (this.actionIds.length === 0) {
            this.$message("请选择税种")
            return
        }
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        ids = arr.join(",");
        Vue.axios
            .post(
                `tax/record/save?period=${this.period}&ids=${ids}&flowType=${this.flowType}&actionIds=${this.actionIds.join(",")}`,
                {}
            )
            .then((res) => {
                this.fetchData();
                this.actionIds = [101, 102, 103, 104]
                this.showAction = false
            });
    }
    batchClick() {
        let arr = [];
        let ids = "";
        if (this.flowType === 2) {
            this.showTax = true;
            return;
        }
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            // this.$message({
            //   type: "warning",
            //   message: "亲，未在申报期内，无法申报！"
            // });
            if (this.purchase === 0 || this.purchase === 2) {
                this.showAction = true
            } else {
                ids = arr.join(",");
                Vue.axios
                    .post(
                        `tax/record/save?period=${this.period}&ids=${ids}&flowType=${this.flowType}`,
                        {}
                    )
                    .then((res) => {
                        this.fetchData();
                    });
            }
        } else {
            this.$message.warning("请选择需要申报的账套");
        }
    }
    // 批量检查
    checkClick() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            // this.$message({
            //   type: "warning",
            //   message: "亲，未在申报期内，无法申报！"
            // });
            ids = arr.join(",");
            Vue.axios
                .post(
                    `tax/record/save?period=${this.period}&ids=${ids
                    }&flowType=${this.flowType}&isPay=${4}`,
                    {}
                )
                .then((res) => {
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要检查的账套");
        }
    }
    // 下载结果
    downLoad(data: any) {
        if (data.resultUrl) {
            let url = data.resultUrl;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }
    }
    // 获取数据
    accounterNo: string = "";
    fetchData() {
        this.batch = 0;
        this.showCheck = false;
        let charge =
            this.chargeStatus.text === "全部" ? "" : this.chargeStatus.id;
        let taxStaxtus =
            this.taxStaxtus.text === "全部" ? "" : this.taxStaxtus.id;
        Vue.axios
            .post(
                `tax/record/quest/list?accountId=${this.$store.state.account.id
                }&period=${this.period}&page=${this.currentPage - 1}&size=${this.pageSize
                }&query=${this.searchQuery}&actionId=${taxStaxtus}&taxState=${charge}&gmtModified=${this.dateValue}&accounterNo=${this.accounterNo}`,
                {}
            )
            .then((res) => {
                console.log(res.data)
                res.data.content.forEach((v: any) => {
                    v.checked = false;
                });
                for (let i = 0; i < res.data.content.length; i++) {
                    if (res.data.content[i].gmtModified != null) {
                        res.data.content[i].gmtModified = this.getTime(
                            new Date(res.data.content[i].gmtModified)
                        );
                    }
                }
                this.clientList = res.data.content;
                this.totalElements = res.data.totalElements;
                this.$forceUpdate();
            });
    }
    // 转化时间
    getTime(date: any) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        let minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        return y + "-" + m + "-" + d;
    }
    getStatus(type: number, code: number) {
        if (type === 0) {
            for (let i = 0; i < this.chargeList.length; i++) {
                if (this.chargeList[i].id === code) return this.chargeList[i].text;
            }
        }
        else {
            for (let i = 0; i < this.taxList.length; i++) {
                if (this.taxList[i].id === code) return this.taxList[i].text;
            }
        }
    }

    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.showCheck = false;
        this.batch = 0;
        if (this.flowType === 33 || this.flowType === 44) this.getList();
        else this.fetchData();
    }

    inAccountBook(data: AccountBookList.AccountBook) {
        Vue.axios.post(`accountbooks/` + data.id).then((res) => {
            this.$store.dispatch("changeAccounBook", res.data);
            this.$utils.setTaxType(res.data);
            this.$utils.getRemarks();
            this.$router.push("/voucherlist");
        });
    }

    /**
     * 客户列表checkbox选中的事件及逻辑处理
     */

    // 全选
    checkAll: boolean = false;
    changeAll(val: boolean) {
        for (let i = 0; i < this.clientList.length; i++) {
            if(this.commandName === "批量申报") {
                if(this.clientList[i].taxState === 5) this.$set(this.clientList[i], "checked", val);
            }
            if(this.commandName === "批量删除") {
                if(this.clientList[i].taxState === 2) this.$set(this.clientList[i], "checked", val);
            }
        }
    }
    // 监听全选
    @Watch("clientList", { deep: true })
    vouchersChange(val: Voucher.Voucher[]) {
        let all = true;
        let hasSelect = false;
        for (let i = 0; i < val.length; i++) {
            if (val[i].checked) {
                hasSelect = true;
            }
        }
        for (let i = 0; i < val.length; i++) {
				if (val[i].checked) {
					hasSelect = true;
				}
			}
			if (hasSelect) this.plBtn = this.commandName;
			else this.plBtn = "取消";
    }
    showImport: boolean = false;
    showReport(data: any) {
        if (data) {
            // if (data.isWarning) return;
            this.records = data;
            this.showImport = true;
        }
    }
    closeImport() {
        this.fetchData();
        this.showImport = false;
    }
    // 修改客户
    showInfo: boolean = false;
    bookData: any | null = null;
    accountModify(data: any) {
        Vue.axios.get(`accountbooks/${data.accountBookId}`).then((res) => {
            this.bookData = res.data;
            this.showInfo = true;
        });
    }
    // 模态框 close
    closeInfo() {
        this.showInfo = false;
    }
    infoSuccess() {
        this.showInfo = false;
        this.fetchData();
    }
    purchase: number = 0;
    flowType: number = 1;
    statistics: any = [];
    total: any = {};
    // 获取统计数据
    getList() {
        let flowType = null;
        if (this.flowType === 44) {
            flowType = 1;
        } else {
            flowType = "";
        }
        let no = "";
        if (this.accounterNo === "") no = this.$store.state.account.no;
        else no = this.accounterNo;
        Vue.axios
            .get(
                `uibot/count?period=${this.period}&page=${this.currentPage - 1
                }&size=${this.pageSize}&accountNo=${no}&flowType=${flowType}`
            )
            .then(res => {
                this.statistics = res.data.data.content;
                this.totalElements = res.data.data.totalElements;
                this.total = res.data.total;
                this.$forceUpdate();
            });
    }

}
